var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoilCar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 24,
    viewBox: "0 0 89 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#525252",
    d: "M3.265 12.188h82.406v3H3.265z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.015 5.599h-.75v9.589h.75v-9.59zM85.771 5.599h-.75v9.589h.75v-9.59z",
    fill: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.956 19.836H20.963v.349h47.993v-.35z",
    fill: "#666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.216 20.093v-1.359h-.35v1.359h.35zM26.352 20.095v-1.359h-.35v1.359h.35zM28.486 20.095v-1.359h-.349v1.359h.35zM61.406 17.884h-.373v2.09h.373v-2.09zM63.175 17.884h-.373v2.09h.373v-2.09z",
    fill: "#666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.128 19.456H52.835v.213h14.293v-.213zM41.886 19.002H24.17v.233h17.716v-.233z",
    fill: "gray"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.844 19.458h2.517c.11 0 .198.089.198.198v1.174a.198.198 0 0 1-.198.197h-2.517a.198.198 0 0 1-.197-.197v-1.174c0-.11.088-.198.197-.198z",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.56 19.655v.266h-2.913v-.265c0-.11.088-.198.197-.198h2.517c.11 0 .198.089.198.198h.002z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.56 20.564v.266a.198.198 0 0 1-.197.197h-2.517a.198.198 0 0 1-.198-.197v-.265h2.914-.001z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.732 17.546h-.373v2.09h.373v-2.09zM45.499 17.546h-.373v2.09h.373v-2.09z",
    fill: "#666"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.171 19.121h2.517c.11 0 .198.089.198.198v1.174a.198.198 0 0 1-.198.198h-2.517a.198.198 0 0 1-.197-.198v-1.174c0-.11.088-.198.197-.198z",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.886 19.319v.265h-2.914v-.265c0-.11.088-.198.197-.198h2.518c.108 0 .197.089.197.198h.002z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.886 20.227v.266a.198.198 0 0 1-.198.198h-2.517a.198.198 0 0 1-.197-.198v-.265h2.914-.002z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.343 17.373H19.606v2.003h10.737v-2.003zM69.431 17.373H54.766v2.003H69.43v-2.003z",
    fill: "#1A1A1A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M84.822 17.856c.72.203 1.452.4 2.13.74.682.334 1.293.835 1.722 1.466l-.142.097a4.17 4.17 0 0 0-.733-.813 4.654 4.654 0 0 0-.92-.603c-.66-.33-1.378-.541-2.1-.727l.043-.16z",
    fill: "#4D4D4D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m89 20.414-.07-.1-.089.062.07.1.09-.062zM88.83 20.531l-.07-.1-.09.062.07.1.09-.062z",
    fill: "#CCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m88.768 19.992.222.319-.348.242-.222-.319a.116.116 0 0 1 .029-.16l.16-.111a.116.116 0 0 1 .16.028l-.001.002zM5.399 17.856c-.72.203-1.452.4-2.131.74a4.438 4.438 0 0 0-1.721 1.466l.141.097c.208-.3.453-.577.734-.813.279-.237.59-.438.919-.603.66-.33 1.379-.541 2.1-.727l-.042-.16z",
    fill: "#4D4D4D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m1.313 20.478.07-.101-.09-.062-.07.1.09.063zM1.477 20.59l.07-.1-.09-.062-.07.1.09.063z",
    fill: "#CCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m1.795 20.236-.222.318-.348-.242.222-.318a.116.116 0 0 1 .161-.03l.16.112a.116.116 0 0 1 .028.16h-.001z",
    fill: "#4D4D4D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.437 17.957h-1.035v2.09h1.035v-2.09zM36.03 17.957h-1.035v2.09h1.035v-2.09zM42.298 17.957h-1.035v2.09h1.035v-2.09z",
    fill: "#666"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.578 18.411h1.575a.373.373 0 0 0 .372-.373v-1.166a.373.373 0 0 0-.372-.372h-1.575a.373.373 0 0 0-.373.372v1.166c0 .206.167.373.373.373z",
    fill: "#333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86.22 16.764a.384.384 0 0 1 .11-.017h1.574c.206 0 .372.166.372.372v1.166a.371.371 0 0 1-.015.107.372.372 0 0 0 .262-.355V16.87a.373.373 0 0 0-.373-.373h-1.576a.374.374 0 0 0-.357.264l.003.002z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m84.73 17.738 3.121.184a.278.278 0 0 0 .293-.276v-.462a.276.276 0 0 0-.293-.276l-3.121.184v.648-.002z",
    fill: "#4D4D4D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m87.185 17.343.617-.005v-.277l-.617.025v.257zM86.445 17.35l.506-.005v-.25l-.506.02v.235zM85.833 17.355l.42-.004v-.228l-.42.017v.215zM85.315 17.36l.356-.003v-.21l-.356.016v.197zM87.185 17.74l.617.025v-.277l-.617-.006v.257zM86.445 17.71l.506.02v-.25l-.506-.004v.235zM85.833 17.685l.42.017v-.228l-.42-.003v.214zM85.315 17.663l.356.016v-.21l-.356-.003v.197zM88.031 18.592h-.199a.173.173 0 0 1-.173-.174v-.126h.546v.126a.173.173 0 0 1-.174.174zM87.143 18.592h-.2a.173.173 0 0 1-.173-.174v-.126h.546v.126a.173.173 0 0 1-.173.174zM1.3 18.214l-.67-.31a.203.203 0 0 1-.118-.184v-.53a.2.2 0 0 1 .117-.183l.67-.31v1.517z",
    fill: "#333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.3 16.697v.099l-.562.259a.228.228 0 0 0-.133.207v.596c0 .012.002.024.004.036a.204.204 0 0 1-.097-.172v-.53c0-.08.046-.15.117-.183l.67-.308v-.004z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.522 16.79v1.334c0 .158-.13.287-.288.287H1.42a.287.287 0 0 1-.196-.076.284.284 0 0 1-.095-.213v-1.335c0-.16.13-.289.29-.289h.815a.287.287 0 0 1 .287.291h.002z",
    fill: "#333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.513 16.723H1.49c-.148 0-.267.2-.267.446v1.168a.284.284 0 0 1-.095-.213v-1.335c0-.16.13-.289.29-.289h.815c.136 0 .25.095.279.223h.001z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m4.87 17.738-3.122.184a.278.278 0 0 1-.293-.276v-.462c0-.16.135-.286.293-.276l3.122.184v.648-.002z",
    fill: "#4D4D4D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m2.415 17.343-.618-.005v-.277l.618.025v.257zM3.153 17.35l-.506-.005v-.25l.506.02v.235zM3.766 17.355l-.42-.004v-.228l.42.017v.215zM4.283 17.36l-.355-.003v-.21l.355.016v.197zM2.415 17.74l-.618.025v-.277l.618-.006v.257zM3.153 17.71l-.506.02v-.25l.506-.004v.235zM3.766 17.685l-.42.017v-.228l.42-.003v.214zM4.283 17.663l-.355.016v-.21l.355-.003v.197z",
    fill: "#333"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M79.41 19.376H69.63l-4.398-1.42h18.578l-4.398 1.42z",
    fill: "#666"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.41 19.376H69.63l-4.398-1.42h18.578l-4.398 1.42z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.41 19.093H69.63l-4.398-1.421h18.578l-4.398 1.421z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M77.573 16.283h-6.105v2.861h6.105v-2.86z",
    fill: "#1A1A1A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M79.021 18.86H70.02a.826.826 0 0 0-.826.826v.996c0 .456.37.825.826.825h9.002c.456 0 .826-.37.826-.825v-.996a.826.826 0 0 0-.826-.826z",
    fill: "#333"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M69.35 23.744a2.752 2.752 0 1 0 0-5.505 2.752 2.752 0 0 0 0 5.505z",
    fill: "gray"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M69.35 23.527a2.536 2.536 0 1 0 0-5.072 2.536 2.536 0 0 0 0 5.072z",
    fill: "#4D4D4D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M69.35 22.758a1.767 1.767 0 1 0 0-3.533 1.767 1.767 0 0 0 0 3.533z",
    fill: "#333"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M69.35 21.545a.553.553 0 1 0 0-1.107.553.553 0 0 0 0 1.107z",
    fill: "#4D4D4D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M79.689 23.744a2.752 2.752 0 1 0 0-5.505 2.752 2.752 0 0 0 0 5.505z",
    fill: "gray"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M79.689 23.527a2.536 2.536 0 1 0 0-5.072 2.536 2.536 0 0 0 0 5.072z",
    fill: "#4D4D4D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M79.689 22.758a1.767 1.767 0 1 0 0-3.533 1.767 1.767 0 0 0 0 3.533z",
    fill: "#333"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M80.242 20.992a.553.553 0 1 1-1.106 0 .553.553 0 0 1 1.106 0zM74.434 20.444h-1.678v.256h1.678v-.256zM74.434 20.902h-1.678v.256h1.678v-.256zM74.434 19.985h-1.678v.256h1.678v-.256z",
    fill: "#4D4D4D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m74.436 20.24-1.68.474v-.255l1.68-.474v.256z",
    fill: "gray"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M74.434 21.362h-1.678v.256h1.678v-.256zM74.434 21.83h-1.678v.254h1.678v-.255z",
    fill: "#4D4D4D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m74.436 20.7-1.68.471v-.255l1.68-.472v.256zM74.436 21.158l-1.68.473v-.256l1.68-.473v.256zM74.436 21.618l-1.68.471v-.255l1.68-.472v.256z",
    fill: "gray"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M74.434 19.527h-1.678v.256h1.678v-.256z",
    fill: "#4D4D4D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m74.436 19.783-1.68.473v-.257l1.68-.472v.256z",
    fill: "gray"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M76.283 20.444h-1.678v.256h1.678v-.256zM76.283 20.902h-1.678v.256h1.678v-.256zM76.283 19.985h-1.678v.256h1.678v-.256z",
    fill: "#4D4D4D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m76.283 20.24-1.678.474v-.255l1.678-.474v.256z",
    fill: "gray"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M76.283 21.362h-1.678v.256h1.678v-.256zM76.283 21.83h-1.678v.254h1.678v-.255z",
    fill: "#4D4D4D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m76.283 20.7-1.678.471v-.255l1.678-.472v.256zM76.283 21.158l-1.678.473v-.256l1.678-.473v.256zM76.283 21.618l-1.678.471v-.255l1.678-.472v.256z",
    fill: "gray"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M76.283 19.527h-1.678v.256h1.678v-.256z",
    fill: "#4D4D4D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m76.283 19.783-1.678.473v-.257l1.678-.472v.256z",
    fill: "gray"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M80.93 19.536a.858.858 0 0 0-.598-.313l-3.72-.283h-4.184l-3.721.283a.851.851 0 0 0-.746 1.118l.273.824h2.711l1.039 1.17a.817.817 0 0 0 .609.273h3.855c.233 0 .455-.1.61-.274l1.038-1.169h2.711l.273-.824a.85.85 0 0 0-.148-.805h-.002zm-9.016 1.195a.199.199 0 0 1-.319.158l-.966-.73v-.43c0-.092.075-.167.166-.167h.952c.092 0 .167.075.167.166v1.003zm4.493.912c0 .191-.154.348-.347.348h-3.082a.348.348 0 0 1-.348-.348V19.91c0-.19.155-.347.348-.347h3.082c.19 0 .347.155.347.347v1.734zm2.002-1.484-.967.73a.199.199 0 0 1-.318-.158v-1.003c0-.091.075-.166.167-.166h.951c.092 0 .167.075.167.166v.431z",
    fill: "gray"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M69.794 20.368h-.887a.179.179 0 0 0-.178.179v.887c0 .098.08.178.178.178h.887c.099 0 .179-.08.179-.178v-.887a.179.179 0 0 0-.179-.179zM80.133 20.368h-.887a.179.179 0 0 0-.179.179v.887c0 .098.08.178.18.178h.886c.099 0 .179-.08.179-.178v-.887a.179.179 0 0 0-.18-.179z",
    fill: "#4D4D4D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M19.409 19.376H9.627l-4.398-1.42h18.578l-4.398 1.42z",
    fill: "#666"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M19.409 19.376H9.627l-4.398-1.42h18.578l-4.398 1.42z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.409 19.093H9.627l-4.398-1.421h18.578l-4.398 1.421z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M17.571 16.283h-6.105v2.861h6.105v-2.86z",
    fill: "#1A1A1A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M19.02 18.86h-9.003a.826.826 0 0 0-.826.826v.996c0 .456.37.825.826.825h9.003c.455 0 .825-.37.825-.825v-.996a.826.826 0 0 0-.825-.826z",
    fill: "#333"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M9.349 23.744a2.752 2.752 0 1 0 0-5.505 2.752 2.752 0 0 0 0 5.505z",
    fill: "gray"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M9.349 23.527a2.536 2.536 0 1 0 0-5.072 2.536 2.536 0 0 0 0 5.072z",
    fill: "#4D4D4D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M9.349 22.758a1.767 1.767 0 1 0 0-3.533 1.767 1.767 0 0 0 0 3.533z",
    fill: "#333"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35 21.545a.553.553 0 1 0 0-1.107.553.553 0 0 0 0 1.107z",
    fill: "#4D4D4D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M19.688 23.744a2.752 2.752 0 1 0 0-5.505 2.752 2.752 0 0 0 0 5.505z",
    fill: "gray"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M19.688 23.527a2.536 2.536 0 1 0 0-5.072 2.536 2.536 0 0 0 0 5.072z",
    fill: "#4D4D4D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M19.688 22.758a1.767 1.767 0 1 0 0-3.533 1.767 1.767 0 0 0 0 3.533z",
    fill: "#333"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M20.241 20.992a.553.553 0 1 1-1.106 0 .553.553 0 0 1 1.106 0zM14.433 20.444h-1.678v.256h1.678v-.256zM14.433 20.902h-1.678v.256h1.678v-.256zM14.433 19.985h-1.678v.256h1.678v-.256z",
    fill: "#4D4D4D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m14.433 20.24-1.678.474v-.255l1.678-.474v.256z",
    fill: "gray"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M14.433 21.362h-1.678v.256h1.678v-.256zM14.433 21.83h-1.678v.254h1.678v-.255z",
    fill: "#4D4D4D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m14.433 20.7-1.678.471v-.255l1.678-.472v.256zM14.433 21.158l-1.678.473v-.256l1.678-.473v.256zM14.433 21.618l-1.678.471v-.255l1.678-.472v.256z",
    fill: "gray"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M14.433 19.527h-1.678v.256h1.678v-.256z",
    fill: "#4D4D4D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m14.433 19.783-1.678.473v-.257l1.678-.472v.256z",
    fill: "gray"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M16.28 20.444h-1.678v.256h1.678v-.256zM16.28 20.902h-1.678v.256h1.678v-.256zM16.28 19.985h-1.678v.256h1.678v-.256z",
    fill: "#4D4D4D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m16.282 20.24-1.68.474v-.255l1.68-.474v.256z",
    fill: "gray"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M16.28 21.362h-1.678v.256h1.678v-.256zM16.28 21.83h-1.678v.254h1.678v-.255z",
    fill: "#4D4D4D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m16.282 20.7-1.68.471v-.255l1.68-.472v.256zM16.282 21.158l-1.68.473v-.256l1.68-.473v.256zM16.282 21.618l-1.68.471v-.255l1.68-.472v.256z",
    fill: "gray"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M16.28 19.527h-1.678v.256h1.678v-.256z",
    fill: "#4D4D4D"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m16.282 19.783-1.68.473v-.257l1.68-.472v.256z",
    fill: "gray"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M20.929 19.536a.857.857 0 0 0-.598-.313l-3.72-.283h-4.184l-3.721.283a.851.851 0 0 0-.746 1.118l.273.824h2.711l1.038 1.17a.817.817 0 0 0 .61.273h3.855c.233 0 .455-.1.61-.274l1.038-1.169h2.711l.273-.824a.849.849 0 0 0-.148-.805h-.002zm-9.016 1.195a.199.199 0 0 1-.319.158l-.966-.73v-.43c0-.092.075-.167.166-.167h.952c.092 0 .167.075.167.166v1.003zm4.493.912c0 .191-.154.348-.347.348h-3.082a.348.348 0 0 1-.348-.348V19.91c0-.19.155-.347.348-.347h3.082c.19 0 .347.155.347.347v1.734zm2.002-1.484-.967.73a.199.199 0 0 1-.318-.158v-1.003c0-.091.075-.166.167-.166h.951c.092 0 .167.075.167.166v.431z",
    fill: "gray"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M9.791 20.368h-.887a.179.179 0 0 0-.178.179v.887c0 .098.08.178.178.178h.887c.099 0 .179-.08.179-.178v-.887a.179.179 0 0 0-.179-.179zM20.13 20.368h-.887a.179.179 0 0 0-.178.179v.887c0 .098.08.178.178.178h.887c.099 0 .179-.08.179-.178v-.887a.179.179 0 0 0-.179-.179z",
    fill: "#4D4D4D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M85.772 15.188H3.265v3.003h82.507v-3.003z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.256 17.672v-1.26H3.784v1.26h81.472z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M47.257 17.774h2.518c.134 0 .243.11.243.244v1.87a.243.243 0 0 1-.243.244h-2.518a.243.243 0 0 1-.243-.244v-1.87c0-.135.109-.244.243-.244z",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.58 17.958h-2.125a.206.206 0 0 0-.206.206v1.578c0 .114.092.206.206.206h2.124a.206.206 0 0 0 .206-.206v-1.578a.206.206 0 0 0-.206-.206z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M50.62 17.774h2.517c.134 0 .243.11.243.244v1.87a.243.243 0 0 1-.243.244h-2.518a.243.243 0 0 1-.243-.244v-1.87c0-.135.109-.244.243-.244z",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.941 17.958h-2.124a.206.206 0 0 0-.206.206v1.578c0 .114.093.206.206.206h2.124a.206.206 0 0 0 .206-.206v-1.578a.206.206 0 0 0-.206-.206z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M82.963 17.102h-.252v4.486h.252v-4.486z",
    fill: "#CCC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M85.506 21.586v-.252h-2.783v.252h2.783zM85.506 20.156v-.252h-2.783v.252h2.783zM85.506 18.729v-.252h-2.783v.252h2.783z",
    fill: "#CCC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M85.506 17.102h-.252v4.486h.252v-4.486zM3.783 17.102h-.252v4.486h.252v-4.486z",
    fill: "#CCC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M6.324 21.588v-.252H3.541v.252h2.783zM6.326 20.158v-.252H3.543v.252h2.783zM6.326 18.729v-.252H3.543v.252h2.783z",
    fill: "#CCC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M6.324 17.102h-.252v4.486h.252v-4.486z",
    fill: "#CCC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.477,
    cy: 7.642,
    r: 7.5,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.485,
    cy: 7.642,
    r: 4.5,
    stroke: "gray",
    strokeWidth: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.477,
    cy: 7.642,
    r: 7.5,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.485,
    cy: 7.642,
    r: 4.5,
    stroke: "gray",
    strokeWidth: 5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.477,
    cy: 7.642,
    r: 7.5,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.485,
    cy: 7.642,
    r: 4.5,
    stroke: "gray",
    strokeWidth: 5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.477,
    cy: 7.642,
    r: 7.5,
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.485,
    cy: 7.642,
    r: 4.5,
    stroke: "gray",
    strokeWidth: 5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.477,
    cy: 7.642,
    r: 7.5,
    fill: "#fff"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.485,
    cy: 7.642,
    r: 4.5,
    stroke: "gray",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoilCar);
export default __webpack_public_path__ + "static/media/coil_car.60a783e7f981d756010e79ab60233c0d.svg";
export { ForwardRef as ReactComponent };